import { AppointmentDTO } from '@interfaces/interfaces';
import React from 'react';

interface IImportDeviceDataContext {
  modalOpen: boolean;
  appointment: AppointmentDTO | null;
  newExamOnly: boolean;
  setModalOpen: (open: boolean) => void;
  setNewExamOnly: (newExamOnly: boolean) => void;
  setAppointment: (appointment: AppointmentDTO | null) => void;
}

const ImportDeviceDataContext = React.createContext<IImportDeviceDataContext>({
  modalOpen: false,
  setModalOpen: () => {},
  appointment: null,
  setAppointment: () => {},
  newExamOnly: true,
  setNewExamOnly: () => {},
});

export default ImportDeviceDataContext;
